export default __webpack_public_path__ + "static/media/hht2_ep6_speaking_03.626d3b9f.png";